import * as React from 'react';

import * as styles from './CardContainer.css';
import { Section } from '../Section';

export interface ICardWrapperProps {
  children: React.ReactNode;
}

export function CardContainer({ children }: ICardWrapperProps) {
  return <Section className={styles['container']}>{children}</Section>;
}
